export const SENTRY_CATCH_APIS = ['order', 'payment'];
